import { useCallback, useEffect, useRef, useState } from "react";

/** โหลดรายการแบบแบ่งหน้า: fetchPage(page) -> { items, hasMore } ; deps เปลี่ยน = เริ่มใหม่ */
export default function useInfinite(fetchPage, deps = []) {
  const [s, setS] = useState({ items: [], page: 0, hasMore: false, loading: true, more: false, error: "" });
  const fnRef = useRef(fetchPage);
  fnRef.current = fetchPage;
  const stateRef = useRef(s);
  stateRef.current = s;
  const token = useRef(0);

  const load = useCallback((page, reset) => {
    const t = ++token.current;
    setS((p) => ({ ...p, loading: reset, more: !reset, error: "" }));
    Promise.resolve()
      .then(() => fnRef.current(page))
      .then((r) => t === token.current && setS((p) => ({ items: reset ? r.items || [] : [...p.items, ...(r.items || [])], page, hasMore: !!r.hasMore, loading: false, more: false, error: "" })))
      .catch((e) => t === token.current && setS((p) => ({ ...p, loading: false, more: false, error: e?.message || "โหลดข้อมูลไม่สำเร็จ" })));
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(1, true); }, deps);
  const loadMore = useCallback(() => {
    const c = stateRef.current;
    if (c.hasMore && !c.loading && !c.more) load(c.page + 1, false);
  }, [load]);
  const reload = useCallback(() => load(1, true), [load]);
  return { ...s, loadMore, reload };
}
